import {useAppSelector} from 'store';
import {getDaysDifference} from 'utils/Helper';

import {formatCampaignDate} from '../../utils';

const CampaignConfirmation: React.FC = () => {
  const {cycleDetails, selectedItems} = useAppSelector((state) => state.promotionCenter);

  return (
    <div className="flex w-full flex-col">
      <div className="flex justify-between border-b border-gray-03 py-2 text-body-sm">
        <span className="text-body-sm-emphasis">تاریخ شروع</span>
        <span>{formatCampaignDate(cycleDetails?.start_date)}</span>
      </div>
      <div className="flex justify-between border-b border-gray-03 py-2 text-body-sm">
        <span className="text-body-sm-emphasis">تاریخ پایان</span>
        <span>{formatCampaignDate(cycleDetails?.end_date)}</span>
      </div>
      <div className="flex justify-between border-b border-gray-03 py-2 text-body-sm">
        <span className="text-body-sm-emphasis">مدت زمان تخفیف</span>
        {cycleDetails?.start_date && cycleDetails?.end_date ? (
          <span>{getDaysDifference(cycleDetails.start_date, cycleDetails.end_date)} روز</span>
        ) : null}
      </div>
      <div className="flex justify-between border-b border-gray-03 py-2 text-body-sm">
        <span className="text-body-sm-emphasis">تعداد کالا</span>
        <span>{selectedItems} کالا</span>
      </div>
    </div>
  );
};

export default CampaignConfirmation;
